module.exports = __webpack_public_path__ + "assets/img/92.4cd9a677.png";